import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function LibraryFeature({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const images = data.images || [];
  const updateImage = (i, src, alt) => {
    const next = images.map((im, idx) => (idx === i ? { src, alt } : im));
    update({ images: next });
  };
  const items = data.callout_items || [];
  const updateItem = (i, t) => {
    const next = [...items];
    next[i] = t;
    update({ callout_items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
          <div className="mt-8 p-6 rounded-2xl bg-olive-light border-l-4 border-accent">
            <EditableText value={data.callout_title} onChange={(t) => update({ callout_title: t })} as="strong" className="text-olive-deep" />
            <ul className="mt-3 space-y-2 text-sm text-ink/70">
              {items.map((it, i) => (
                <li key={i}>• <EditableText value={it} onChange={(t) => updateItem(i, t)} as="span" /></li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="grid grid-cols-2 gap-4">
            {images.map((im, i) => (
              <EditableImage
                key={i}
                src={im.src}
                alt={im.alt || 'Library'}
                onChange={(src, alt) => updateImage(i, src, alt)}
                className={`rounded-3xl shadow-soft object-cover ${i === 0 ? 'col-span-2 h-72' : 'h-56'} w-full`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default LibraryFeature;
